module.exports = __webpack_public_path__ + "fonts/BasierSquare-SemiBold.c7f9ed5.woff";